export default __webpack_public_path__ + "static/oweek-565e072c54d5960d4290a76555cdbcf5.jpeg";